import Image from './Image'
import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import useIntersectionObserver from 'hooks/use-intersection-observer'
import useStyles from './styles'

const defaultThumb =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII='

const LazyImage = ({ src, alt = '', width = 100, height = 100, className, thumb = defaultThumb }) => {
    const classes = useStyles({ width, height })
    const ref = React.useRef()
    const [isVisible, setIsVisible] = React.useState(false)

    const canIntersect = useIntersectionObserver({
        target: ref,
        onIntersect: ([{ isIntersecting }], observerElement) => {
            if (isIntersecting && !isVisible) setIsVisible(true)
            if (isIntersecting) observerElement.unobserve(ref.current)
        },
    })

    return (
        <div ref={ref} className={clsx(className, classes.imageContainer)}>
            {(!canIntersect || isVisible) && <Image src={src} thumb={thumb} alt={alt} />}
        </div>
    )
}

LazyImage.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    thumb: PropTypes.string,
}

export default LazyImage
